<template>
    <div class="action_rule">
        <div class="discount_type" v-if="!is_catalog">
            <yes_no
                key="DISCOUNT_TYPE"
                title="DISCOUNT_TYPE"
                v-model="discount_type"
                :radio_options="radio_options"
            >
            </yes_no>
        </div>

        <div class="discount_rule" v-if="!is_catalog">
            <div class="simple_val" v-if="is_simple">
                <info_field f_uniq="ct"
                            f_type="discount_val"
                            :is_disabled="false"
                            @update_categ="change_atr"
                            :f_title="__t('PWA.DISCOUNT_VAL')"
                            :f_val="cur_item.discount_val">
                </info_field>
            </div>

            <div class="products_list mt-4" v-else>
                <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" @click="add_prod">
                    <span class="fal fa-eject mr-1"></span>
                    {{ __t('ADD') }}
                </button>

                <action_params_gift
                    v-for="block in gift_blocks"
                    :key="block.id"
                    :block="block"
                    :is_catalog="is_catalog"
                    @update="update_block"
                    @remove="remove_block(block.id)"
                />
            </div>
        </div>


        <div class="products_list mt-4" v-else>
            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" @click="add_prod">
                <span class="fal fa-eject mr-1"></span>
                {{ __t('ADD') }}
            </button>

            <action_params_gift
                v-for="block in gift_blocks"
                :key="block.id"
                :block="block"
                :is_catalog="is_catalog"
                @update="update_block"
                @remove="remove_block(block.id)"
            />
        </div>

    </div>
</template>

<script>
import yes_no from "../../../../sys/radio/yes_no.vue";
import Info_field from "../../../../sys/info_field.vue";
import action_params_gift from "./action_params_gift.vue";

export default {
    name: "action_params",
    components: {Info_field, yes_no,action_params_gift},

    created() {
        this.cur_item = this.action;
    },

    data() {
        return {
            cur_item: {},
        }
    },
    props: {
        action: {
            type: Object
        }
    },

    methods: {

        add_prod() {
            const block = {
                id: Date.now(),
                products: [],
                min_order: '',
                on_choice: false
            };

            const updated = [...this.gift_blocks, block];
            this.gift_blocks = updated;
        },

        update_block(updatedBlock) {
            const updated = this.gift_blocks.map(b => b.id === updatedBlock.id ? updatedBlock : b);
            this.gift_blocks = updated;
        },

        remove_block(id) {
            const updated = this.gift_blocks.filter(b => b.id !== id);
            this.gift_blocks = updated;
        },

        change_atr(atr_name, atr_val) {
            /*if(this.is_simple) {
                atr_val = parseInt(atr_val);
            }*/

            this.$emit('on_change_attribute',atr_name,atr_val);
        },

    },

    computed: {

        gift_blocks: {
            get : function() {
                return this.cur_item?.gift_blocks || [];
            },

            set : function(val) {
                this.change_atr('gift_blocks', val);
            }
        },

        cur_group() {
            return this.cur_item.active_group ?? {
                "type" : ""
            };
        },

        radio_options() {
            let def = [
                {text: 'ACTION.GIFT',     value: 'gift'},
                {text: 'ACTION.PERCENT',  value: 'percent'},
                {text: 'ACTION.DISCOUNT', value: 'discount'},
            ];

            if(this.is_catalog) {
                def = def.filter(opt => {
                    return opt.value == 'percent' || opt.value == 'discount';
                });
            }


            return def;
        },

        is_simple() {
            return this.discount_type === 'discount' || this.discount_type === 'percent'
        },

        is_delivery() {
            return this.discount_type === 'delivery';
        },

        is_catalog() {
            return this.cur_group.type === 'catalog';
        },

        discount_type: {
            get :function () {
                if(this.cur_item.hasOwnProperty("discount_type")) {
                    if(this.cur_item.discount_type.length >= 0) {
                        return this.cur_item.discount_type
                    }
                }

                return "gift";
            },

            set: function (val) {
                this.change_atr('discount_type',val);
            },
        },

    },


}
</script>


<style scoped>

</style>
